import { useMemo, useState } from "react";

import { type SortByType } from "src/graphql/generated/types";

export function useSort(args: {
  defaultSort: SortByType;
  secondarySort?: SortByType;
}): {
  currentSort: SortByType;
  updateSort: (newSort: SortByType) => void;
  allSorts: Array<SortByType>;
} {
  const [currentSort, updateSort] = useState<SortByType>(args.defaultSort);

  const allSorts = useMemo(() => {
    const sorts: Array<SortByType> = [currentSort];
    if (args.secondarySort && args.secondarySort.key !== currentSort.key) {
      sorts.push(args.secondarySort);
    }
    return sorts;
  }, [currentSort, args.secondarySort]);

  return {
    currentSort,
    updateSort,
    allSorts,
  };
}
